import { Button, LoadingButton } from "components/form";
import React, { useState } from "react";
import { toast } from "sonner";
import OptionRowSkipSurvey from "./OptionRowSkipSurvey";
import { useTranslation } from "react-i18next";

const SkipSurvey = ({
  indexValue,
  handleClose,
  selectedQues,
  selectedBlock,
  skipDropdownList,
  surveyQuestionArray,
  setSurveyQuestionArray,
}) => {
  //********************************** Handle All State *********************************//

  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);

  const [skipQuestionSelected, setSkipQuestionSelected] = useState({
    ...selectedQues,
  });

  const { t } = useTranslation();

  const [
    surveyQuestionArrCloneWithSkipQues,
    setSurveyQuestionArrCloneWithSkipQues,
  ] = useState(null);

  //*********************************** Handle All Function *********************************//

  //   question dropdown onChange Handler
  const questionDropdownOnChangeHandler = (
    option,
    ind,
    e,
    setSelectedOption
  ) => {
    const { value } = e?.target;

    if (value) {
      let surveyQuesArrClone = { ...surveyQuestionArray };
      let blockQuesArrClone = surveyQuesArrClone[selectedBlock];

      // if (value === "isSurveyEnd") {
      //   blockQuesArrClone[indexValue] = {
      //     ...skipQuestionSelected,
      //     option: skipQuestionSelected?.option?.map((el, i) => {
      //       if (i === ind) {
      //         return {
      //           ...option,
      //           questionNumber: "",
      //           isSurveyEnd: true,
      //         };
      //       } else {
      //         return {
      //           ...el,
      //         };
      //       }
      //     }),
      //   };
      // } else if (value === "isBlockEnd") {
      //   blockQuesArrClone[indexValue] = {
      //     ...skipQuestionSelected,
      //     option: skipQuestionSelected?.option?.map((el, i) => {
      //       if (i === ind) {
      //         return {
      //           ...option,
      //           questionNumber: "",
      //           isBlockEnd: true,
      //         };
      //       } else {
      //         return {
      //           ...el,
      //         };
      //       }
      //     }),
      //   };
      // } else {
      //   blockQuesArrClone[indexValue] = {
      //     ...skipQuestionSelected,
      //     option: skipQuestionSelected?.option?.map((el, i) => {
      //       if (i === ind) {
      //         return {
      //           ...option,
      //           questionNumber: value,
      //         };
      //       } else {
      //         return {
      //           ...el,
      //         };
      //       }
      //     }),
      //   };
      // }

      const updatedOption = skipQuestionSelected?.option?.map((el, i) =>
        i === ind
          ? {
              ...option,
              questionNumber:
                value === "isSurveyEnd" || value === "isBlockEnd" ? "" : value,
              ...(value === "isSurveyEnd" && { isSurveyEnd: true }),
              ...(value === "isBlockEnd" && { isBlockEnd: true }),
            }
          : el
      );

      blockQuesArrClone[indexValue] = {
        ...skipQuestionSelected,
        option: updatedOption,
      };

      setSkipQuestionSelected(blockQuesArrClone[indexValue]);

      surveyQuesArrClone = {
        ...surveyQuesArrClone,
        [selectedBlock]: blockQuesArrClone?.map((el) => el),
      };

      setSelectedOption(value);
      setSurveyQuestionArrCloneWithSkipQues(surveyQuesArrClone);
    }
  };

  //   skip survey confirm handler
  const skipSurveyOnConfirmHandler = () => {
    if (surveyQuestionArrCloneWithSkipQues !== null) {
      setSurveyQuestionArray(surveyQuestionArrCloneWithSkipQues);
      toast.success(t(`CUSTOMIZATION_QUESTION.skipLogicAddSuccessfully`));
      handleClose();
    }
  };

  //************************************** Handle HTML CODE *********************************//
  return (
    <div className="">
      <h3>{t(`CUSTOMIZATION_QUESTION.skipLogic`)}</h3>
      <p>{selectedQues?.question || "----"}</p>
      {selectedQues?.option?.length > 0 &&
        selectedQues?.option?.map((option, index) => {
          return (
            <div key={`skipQuesOpt${index}`}>
              <OptionRowSkipSurvey
                ind={index}
                optionData={option}
                skipDropdownList={skipDropdownList}
                questionDropdownOnChangeHandler={
                  questionDropdownOnChangeHandler
                }
              />
            </div>
          );
        })}

      <div className="button_wrap button_center">
        <Button className={"light"} onClick={handleClose}>
          {t("CUSTOMIZATION_QUESTION.cancel")}
        </Button>

        <LoadingButton
          loading={submitButtonLoading}
          onClick={skipSurveyOnConfirmHandler}
          disabled={!surveyQuestionArrCloneWithSkipQues}
        >
          {t("CUSTOMIZATION_QUESTION.confirm")}
        </LoadingButton>
      </div>
    </div>
  );
};

export default SkipSurvey;
